import Vue from 'vue';

import jquery from 'jquery';
import 'bootstrap';
import "./assets/iconfont/iconfont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "font-awesome/css/font-awesome.css";
import axios from 'axios';
import qs from 'qs';
import md from 'js-md5';
import store from './store/store';

import App from './App.vue';
import router from './router';
Vue.config.productionTip = false
Vue.prototype.jquery = jquery
Vue.prototype.axios = axios
Vue.prototype.qs=qs
Vue.prototype.md=md
// Vue.prototype.laydate=laydate
// Vue.prototype.url='http://127.0.0.1:80';
// Vue.prototype.url='http://10.0.68.15:80';
// Vue.prototype.api='http://10.0.63.17:3000';
let host_ori = window.location.origin == 'http://127.0.0.1' ? 'http://gm.wanyuhudong.cn' : window.location.origin;
// let host_ori = "http://gm.wanyuhudong.cn";
Vue.prototype.url = host_ori;

// Vue.prototype.api='http://8.217.108.218:80/appi';
// Vue.prototype.api='http://47.100.0.107/appi';
// Vue.prototype.api='http://10.0.68.131:3000';
Vue.prototype.api = host_ori + '/appi';
// Vue.prototype.api='http://10.0.63.17:3000';
// Vue.prototype.api='http://10.0.68.15:3000';
// Vue.prototype.img_url='http://152.136.167.127:80/imgs/';
Vue.prototype.img_url = host_ori + '/imgs/';
// Vue.prototype.img_url='http://10.0.68.15:3000/imgs/';
// Vue.prototype.url='http://10.0.68.15:8080';
// Vue.prototype.api='http://10.0.68.15:8080/appi';



//Vue.prototype.bootstrap = bootstrap
// Vue.prototype.bootstrapjs = bootstrapjs
if (module.hot) {
  module.hot.accept();
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

